import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppResponse } from '@data/app/response';
import { environment } from '@environments/environment';
import { ApiPaths } from '@mpg-core/constants/api-paths.enum';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuditLogsService {

  constructor(private http: HttpClient){}

  getPublishHistory(): Observable<any> {
    return this.http.get<any>(environment.reportUrl+ ApiPaths.getPublishHistory).pipe(
      map((res: AppResponse) => {
        return res;
      })
    );
  }

  getActivityData(): Observable<any> {
    return this.http.get<any>(environment.apiUrl+ ApiPaths.getActitvityData).pipe(
      map((res: AppResponse) => {
        return res;
      })
    );
  }

  getChangePriorActivityData(): Observable<any> {
    return this.http.get<any>(environment.apiUrl+ ApiPaths.getChangePriorTrackerInfo).pipe(
      map((res: AppResponse) => {
        return res;
      })
    );
  }

}
